import script from "./ManageEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageEvents.vue?vue&type=script&setup=true&lang=js"

import "./ManageEvents.vue?vue&type=style&index=0&id=0f24f324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f24f324"]])

export default __exports__